
enum EmployeeDepartmentCodes {
  ACCOUNTING = "ACCOUNTING",
  BUSINESS_OPERATIONS = "BUSINESS_OPERATIONS",
  BUSOPS_CUSTOMER_SERVICE = "BUSOPS_CUSTOMER_SERVICE",
  CLERICAL = "CLERICAL",
  EXECUTIVE = "EXECUTIVE",
  FIELD_SERVICES = "FIELD_SERVICES",
  HUMAN_RESOURCES = "HUMAN_RESOURCES",
  INFORMATION_TECHNOLOGY = "INFORMATION_TECHNOLOGY",
  LOSS_DRAFT = "LOSS_DRAFT",
  RECRUITING = "RECRUITING",
  SALES_INSURANCE = "SALES_INSURANCE",
  SALES_VALUATIONS = "SALES_VALUATIONS",
  TELEPHONE_SERVICES = "TELEPHONE_SERVICES",
  TRAINING = "TRAINING",
  VALUATION_CUSTOMER_SERVICE = "VALUATION_CUSTOMER_SERVICE",
  VALUATION_FIELD_SERVICE = "VALUATION_FIELD_SERVICE",
  VALUATION_QUALITY_SERVICE = "VALUATION_QUALITY_SERVICE",
  BUSINESS_DEVELOPMENT = "BUSINESS_DEVELOPMENT",
  CUSTOMER_SERVICE = "CUSTOMER_SERVICE",
  FIELD_OPERATIONS = "FIELD_OPERATIONS",
  FIELD_SCHEDULING = "FIELD_SCHEDULING",
};

enum EmployeeDepartmentNames {
  ACCOUNTING = "Accounting",
  BUSINESS_OPERATIONS = "Business Operations",
  BUSOPS_CUSTOMER_SERVICE = "BusOps Customer Service",
  CLERICAL = "Clerical",
  EXECUTIVE = "Executive",
  FIELD_SERVICES = "Field Services",
  HUMAN_RESOURCES = "Human Resources",
  INFORMATION_TECHNOLOGY = "Information Technology",
  LOSS_DRAFT = "Loss Draft",
  RECRUITING = "Recruiting",
  SALES_INSURANCE = "Sales Insurance",
  SALES_VALUATIONS = "Sales Valuations",
  TELEPHONE_SERVICES = "Telephone Services",
  TRAINING = "Training",
  VALUATION_CUSTOMER_SERVICE = "Valuation Customer Service",
  VALUATION_FIELD_SERVICE = "Valuation Quality Service",
  VALUATION_QUALITY_SERVICE = "Valuation Quality Service",
  BUSINESS_DEVELOPMENT = "Business Development",
  CUSTOMER_SERVICE = "Customer Service",
  FIELD_OPERATIONS = "Field Operations",
  FIELD_SCHEDULING = "Field Scheduling",
};

export const EmployeeDepartmentOptions = [
  { label: EmployeeDepartmentNames.ACCOUNTING, value: EmployeeDepartmentCodes.ACCOUNTING},
  { label: EmployeeDepartmentNames.BUSINESS_OPERATIONS, value: EmployeeDepartmentCodes.BUSINESS_OPERATIONS},
  { label: EmployeeDepartmentNames.BUSOPS_CUSTOMER_SERVICE, value: EmployeeDepartmentCodes.BUSOPS_CUSTOMER_SERVICE},
  { label: EmployeeDepartmentNames.CLERICAL, value: EmployeeDepartmentCodes.CLERICAL},
  { label: EmployeeDepartmentNames.EXECUTIVE, value: EmployeeDepartmentCodes.EXECUTIVE},
  { label: EmployeeDepartmentNames.FIELD_SERVICES, value: EmployeeDepartmentCodes.FIELD_SERVICES},
  { label: EmployeeDepartmentNames.HUMAN_RESOURCES, value: EmployeeDepartmentCodes.HUMAN_RESOURCES},
  { label: EmployeeDepartmentNames.INFORMATION_TECHNOLOGY, value: EmployeeDepartmentCodes.INFORMATION_TECHNOLOGY},
  { label: EmployeeDepartmentNames.LOSS_DRAFT, value: EmployeeDepartmentCodes.LOSS_DRAFT},
  { label: EmployeeDepartmentNames.RECRUITING, value: EmployeeDepartmentCodes.RECRUITING},
  { label: EmployeeDepartmentNames.SALES_INSURANCE, value: EmployeeDepartmentCodes.SALES_INSURANCE},
  { label: EmployeeDepartmentNames.SALES_VALUATIONS, value: EmployeeDepartmentCodes.SALES_VALUATIONS},
  { label: EmployeeDepartmentNames.TELEPHONE_SERVICES, value: EmployeeDepartmentCodes.TELEPHONE_SERVICES},
  { label: EmployeeDepartmentNames.TRAINING, value: EmployeeDepartmentCodes.TRAINING},
  { label: EmployeeDepartmentNames.VALUATION_CUSTOMER_SERVICE, value: EmployeeDepartmentCodes.VALUATION_CUSTOMER_SERVICE},
  { label: EmployeeDepartmentNames.VALUATION_FIELD_SERVICE, value: EmployeeDepartmentCodes.VALUATION_FIELD_SERVICE},
  { label: EmployeeDepartmentNames.VALUATION_QUALITY_SERVICE, value: EmployeeDepartmentCodes.VALUATION_QUALITY_SERVICE},
  { label: EmployeeDepartmentNames.BUSINESS_DEVELOPMENT, value: EmployeeDepartmentCodes.BUSINESS_DEVELOPMENT},
  { label: EmployeeDepartmentNames.CUSTOMER_SERVICE, value: EmployeeDepartmentCodes.CUSTOMER_SERVICE},
  { label: EmployeeDepartmentNames.FIELD_OPERATIONS, value: EmployeeDepartmentCodes.FIELD_OPERATIONS},
  { label: EmployeeDepartmentNames.FIELD_SCHEDULING, value: EmployeeDepartmentCodes.FIELD_SCHEDULING},
];

// Limited list of departments used for CS Incidents
export const CustomerServiceDeptOptions = [
  { label: EmployeeDepartmentNames.BUSINESS_OPERATIONS, value: EmployeeDepartmentCodes.BUSINESS_OPERATIONS},
  { label: EmployeeDepartmentNames.CUSTOMER_SERVICE, value: EmployeeDepartmentCodes.CUSTOMER_SERVICE},
  { label: EmployeeDepartmentNames.FIELD_SERVICES, value: EmployeeDepartmentCodes.FIELD_SERVICES},
];